interface Props {
  onClick: () => void;
}
const SvgFabPhone: React.FC<Props> = ({ onClick }) => {
  return (
    <svg
      style={{ cursor: "pointer", marginTop: -8 }}
      onClick={onClick}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g >
        <circle cx="32" cy="32" r="24" className={"fill-secondary"} />
      </g>
      <g clipPath="url(#clip0_24_553)">
        <path
          d="M29.5205 22.0069C29.1914 21.983 28.8541 22.0166 28.5234 22.1143L27.3398 22.4649C26.0786 22.8379 25.0932 23.8386 24.7598 25.1016C24.0195 27.9105 24.8663 31.2352 27.0703 34.9776C29.2712 38.7149 31.779 41.0901 34.6113 41.8653C35.8868 42.2144 37.2624 41.8809 38.2285 40.9835L39.1289 40.1485C40.1364 39.2131 40.2866 37.655 39.4727 36.5479L38.1719 34.7813C37.4746 33.8343 36.2455 33.431 35.1152 33.7706L33.0801 34.38C32.9946 34.4049 32.7902 34.2886 32.6123 34.1349L32.6113 34.1339C32.2945 33.8583 31.8554 33.3014 31.3857 32.505V32.504C30.8821 31.6486 30.6673 31.0892 30.5811 30.7589C30.4948 30.4284 30.5157 30.3882 30.5283 30.2765C30.5349 30.2207 30.5614 30.1691 30.6064 30.128L30.6074 30.127L32.125 28.7393C32.9944 27.9445 33.2569 26.6743 32.7666 25.6056L31.8516 23.6095V23.6085C31.4208 22.6694 30.5076 22.0787 29.5205 22.0069ZM29.4121 23.503C29.8712 23.5373 30.294 23.8127 30.4873 24.2345L31.4033 26.2306C31.625 26.7138 31.5138 27.2667 31.1133 27.6329L29.5957 29.0196C29.2846 29.3033 29.0856 29.69 29.0381 30.1075V30.1085C29.0257 30.2183 28.9964 30.6265 29.1299 31.1378C29.2633 31.649 29.5389 32.3252 30.0928 33.2657H30.0937C30.6105 34.1422 31.099 34.8081 31.6279 35.2677H31.6289C31.8007 35.4164 32.5206 36.1064 33.5 35.8204L33.5029 35.8194L35.5469 35.2071C36.0776 35.0477 36.6451 35.2381 36.9639 35.671L38.2646 37.4376C38.633 37.9394 38.5686 38.6216 38.1084 39.0489L37.208 39.8849C36.6322 40.42 35.7771 40.6289 35.0068 40.4181C32.7172 39.7913 30.4514 37.7627 28.3633 34.2169C26.2723 30.6663 25.6182 27.7296 26.21 25.4845C26.4056 24.7435 27.0048 24.1284 27.7656 23.9034L28.9482 23.5528C29.1023 23.5073 29.2591 23.4916 29.4121 23.503Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_24_553"
          x="0"
          y="0"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24_553" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_24_553" result="shape" />
        </filter>
        <clipPath id="clip0_24_553">
          <rect width="24" height="24" fill="white" transform="translate(20 20)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgFabPhone;
